export default __webpack_public_path__ + "traktor.75eb71ec.png";